module.exports = __webpack_public_path__ + "static/texture-f696009d66c21d3eb68fd6f8ddab1659.png";